import { Theme } from '@mui/material'

const useStyles = {
  channelTooltipContent: { maxWidth: '120px', fontWeight: 'normal', fontSize: '10px', lineHeight: '14px', textAlign: 'center' } as const,
  channelBubble: {
    width: '44px',
    height: '44px',
    borderRadius: '100px',
    position: 'relative',
  },
  alertIcon: (theme: Theme) =>
    ({
      position: 'absolute',
      bottom: '-5px',
      right: '-4px',
      backgroundColor: theme.palette.common.white,
      borderRadius: '100px',
      height: '20px',
    }) as const,
  labelContainer: (theme: Theme) => ({ textAlign: 'center', whiteSpace: 'normal', lineHeight: 1, marginTop: theme.spacing(1) }),
  label: { lineHeight: 1 },
  ppmLabel: { display: 'block', lineHeight: 1 },
  ammWarningLabel: { textAlign: 'center', lineHeight: 1 },
}
export default useStyles
